import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Utils from '../../../lib/utils';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import * as resetActions from './actions';
import AuthFormHeader from '../common/AuthFormHeader';
import SpinnerLoader from '../../common/loader/SpinnerLoader';
import './resetForm.css';

class ResetForm extends React.Component {
  constructor(props) {
    let resetStrings = props.local.strings.auth.reset;
    if(props.login.profile.MustRenewPass !== 1) {
      props.history.push('/login');
    }
    super(props);
    this.state = {
      password: '',
      passwordAgain: '',
      passwordErrorMsg1: resetStrings.passwordRequired,
      passwordErrorMsg2: resetStrings.passwordRequired,
      passwordShowError1: '',
      passwordShowError2: '',
      showPassword: false,
      showPasswordAgain: false,
      isSubmitting: false
    };
  }

  onPasswordChange = (event) => {
    const val = event.target.value;
    const isValidPassword = Utils.checkPasswordStrength(val);
    let newState = {
      password: val,
      passwordShowError1: '',
      passwordErrorMsg1: this.props.local.strings.auth.reset.passwordRequired
    };

    if (!val) {
      newState.passwordShowError1 = 'show-error';
    } else if (isValidPassword && isValidPassword.errorMessage) {
      newState.passwordErrorMsg1 = isValidPassword.errorMessage;
      newState.passwordShowError1 = 'show-error';
    }
    this.setState(newState);
  }

  onPasswordAgainChange = (event) => {
    const val = event.target.value;
    let newState = {};
    if(!val) {
      newState.passwordShowError2 = 'show-error';
    }
    else {
      newState.passwordShowError2 = '';
    }
    newState.passwordAgain = val;
    this.setState(newState);
  }

  sendResetForm = (event) => {
    let resetStrings = this.props.local.strings.auth.reset;
    event.preventDefault();
    let newState = {}, valid = true;

    if(!this.state.password) {
      newState.passwordShowError1 = 'show-error';
      valid = false;
    } 
    else {
      newState.passwordShowError1 = '';
    }

    if(!this.state.passwordAgain) {
      newState.passwordShowError2 = 'show-error';
      valid = false;
    } 
    else {
      newState.passwordShowError2 = '';
    }
    if(valid) {
      if(this.state.password === this.state.passwordAgain) {
        this.setState({isSubmitting: true})
        this.props.actions.sendResetData({
          newPassword: this.state.password, 
          oldPassword: this.props.login.password
        }, this.props.history).then(() => {
              this.setState({
                isSubmitting: false
              });
            }).catch(() => {
                this.setState({
                  isSubmitting: false
                });
              });;
      }
      else {
        newState.passwordErrorMsg2 = resetStrings.passwordBoth;
        newState.passwordShowError2 = 'show-error';
      }
    }
    this.setState(newState);
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  togglePasswordAgainVisibility = () => {
    this.setState((prevState) => ({
      showPasswordAgain: !prevState.showPasswordAgain,
    }));
  };

  render() {
    let resetStrings = this.props.local.strings.auth.reset;
    const progressBar = Utils.checkPasswordStrength(this.state.password);
    return (
      <div className="form-wrapper col-custom-padding col-md-4 col-sm-12">

        <AuthFormHeader subtitle={resetStrings.subTitleHeader} />

        <form className='auth-form forgot-form'>
          <div className="step-body">
            {this.state.password && progressBar && progressBar.strength && (
                <div className="progress-bar-container">
                    <p
                      className="progress-bar-text"
                      style={{ color: progressBar.strength.color || '#dc3545' }}
                    >
                      {progressBar.strength.text || 'Weak'}
                    </p>
                    <div className="progress-bar">
                      <div
                        className="progress-strength"
                        style={{
                            width: `${progressBar.percentage || 0}%`,
                            backgroundColor: progressBar.strength.color || '#dc3545',
                          }}
                        />
                    </div>
                </div>
            )}
            <div className="field-wrapper">
              <input 
                type={this.state.showPassword ? 'text' : 'password'}
                name="password"
                placeholder={resetStrings.newPasswordPlaceholder}
                onChange={this.onPasswordChange}
                onBlur={this.onPasswordChange}
                value={this.state.password}
              />
              <span
                  onClick={this.togglePasswordVisibility}
                  className="icon"
                >
                  {this.state.showPassword ? <FaEye /> : <FaEyeSlash />}
                </span>
              <span className={`errorMessage ${this.state.passwordShowError1}`}>{this.state.passwordErrorMsg1}</span>
            </div>
            <div className="field-wrapper">
              <input 
                type={this.state.showPasswordAgain ? 'text' : 'password'}
                name="retypepassword"
                placeholder={resetStrings.retypePasswordPlaceholder}
                onChange={this.onPasswordAgainChange}
                onBlur={this.onPasswordAgainChange}
                value={this.state.passwordAgain}
              />
              <span
                onClick={this.togglePasswordAgainVisibility}
                className="icon"
              >
                {this.state.showPasswordAgain ? <FaEye /> : <FaEyeSlash />}
              </span>
              <span className={`errorMessage ${this.state.passwordShowError2}`}>{this.state.passwordErrorMsg2}</span>
            </div>
          </div>
          <div className="button-forgot-wrapper">
            <button 
              onClick={this.sendResetForm}
              disabled={this.state.isSubmitting}
              className={`bn-small send-form-recover bn bg-blue-gradient bn-forgot ${this.state.isSubmitting ? 'disabled' : ''}`}
            >
              Change Password
              {this.state.isSubmitting && <SpinnerLoader/>}
            </button>
            <span className="server-error-reset">{this.props.reset.errorReset}</span>
          </div>
        </form>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    reset: state.reset,
    login: state.login,
    local: state.localization
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(resetActions, dispatch)
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ResetForm));